import React from 'react';
import './index.module.less';
import HalfScreenInfoModal from '@components/HalfScreenInfoModal';
import CommonBtn from '@components/CommonBtn';
import ConfirmModal from '@components/ConfirmModal';
import BrowserHistory from '@helpers/BrowserHistory';
import { Api } from '@apis/client';
import Http from '@helpers/Http';
import * as Cache from '@helpers/Cache';
import { BtnStyle, ConfirmBtnStyle, IPlaceItem } from '../constants';
import useUrlParams from '@helpers/useUrlParams';

//私有常量

//可抽离的逻辑处理函数/组件

let SettingMenu = (props: IProps) => {
  //变量声明、解构
  const { onRequestData, onClose, place } = props;
  const params = useUrlParams();

  //网络IO
  const deletePlace = async () => {
    await Http.post(Api.DeleteMobileRegionStayV1, {
      uid: place.uid,
    });
    onRequestData();
  };

  //逻辑处理函数
  // 修改常去地点
  const handleClickChangePlace = () => {
    // 暂存 place 数据
    Cache.save(place.uid, place);
    BrowserHistory.push(
      `${PUBLIC_URL}/mapFrequentedPlace?snCode=${params.snCode}&company=${params.company}&actionType=edit&placeUid=${place.uid}`,
    );
  };

  // 删除常去地点
  const handleClickDelete = () => {
    onClose && onClose();
    ConfirmModal.show({
      title: '确认删除？',
      text: '删除后，将无法恢复。',
      cancelBtnText: '取 消',
      confirmBtnText: '删 除',
      showCancelBtn: true,
      confirmBtnStyle: ConfirmBtnStyle,
      cancelBtnStyle: { fontSize: '0.32rem' },
      onConfirm: deletePlace,
    });
  };

  //组件Effect

  return (
    <HalfScreenInfoModal height="4.8rem" onClose={onClose} hideCloseBtn={true}>
      <div styleName="container">
        <div styleName="menu-item" onClick={handleClickChangePlace}>
          修改常去地点
        </div>
        <div styleName="menu-item" onClick={handleClickDelete}>
          删除
        </div>
      </div>
      <CommonBtn
        type="fixed"
        btnText="取 消"
        onConfirm={onClose}
        style={BtnStyle}
      />
    </HalfScreenInfoModal>
  );
};

//props类型定义
interface IProps {
  /**
   * 点击时选中的地区
   */
  place: IPlaceItem;
  /**
   * 重新请求数据
   */
  onRequestData: () => void;
  onClose: () => void;
}

//prop-type定义，可选

export default SettingMenu;
